import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
  deleteAllItems,
  deleteAllItemsExcept,
  deleteItem,
  deleteItems,
  getTotalItems,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { USERS } from '../../data/users';
import { IUser, User } from '../../model/user';
import { IUsersApiService } from './users-api.interface';
import { CreateUserRequestDto } from './dtos/create-user.request.dto';
import { CreateUserResponseDto } from './dtos/create-user.response.dto';
import { UpdateUserRequestDto } from './dtos/update-user.request.dto';
import { UpdateUserResponseDto } from './dtos/update-user.response.dto';

@Injectable({
  providedIn: 'root',
})
export class UsersMockApiService implements IUsersApiService {
  data = {
    users: {
      items: [...USERS],
      queryOptions: { page: 1, size: 10 } as QueryOptions<IUser>,
      subject: new BehaviorSubject<Maybe<User[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get usersData() {
    return this.data['users'] as Data<User, IUser>;
  }

  createUser(data: CreateUserRequestDto): Promise<CreateUserResponseDto> {
    throw new Error('Method not implemented.');
  }

  updateUser(
    userId: number,
    data: UpdateUserRequestDto,
  ): Promise<UpdateUserResponseDto> {
    throw new Error('Method not implemented.');
  }

  deleteUser(userId: User['id']): Observable<IUser> {
    return deleteItem(this.usersData, userId);
  }

  deleteUsers(userIds: User['id'][]): Observable<IUser[]> {
    return deleteItems(this.usersData, userIds);
  }

  deleteAllUsers(): Observable<IUser[]> {
    return deleteAllItems(this.usersData);
  }

  deleteAllUsersExcept(userIds: User['id'][]): Observable<IUser[]> {
    return deleteAllItemsExcept(this.usersData, userIds);
  }

  getTotalUsers(): Observable<Maybe<number>> {
    return getTotalItems(this.usersData);
  }
}
